import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'

export const ScrollToError: React.FC = () => {
  const { submitCount, errors, touched } = useFormikContext<any>()

  useEffect(() => {
    if (submitCount <= 0) {
      return
    }

    const el = document.querySelector('.Mui-error, [data-error]')

    if (!el) {
      return
    }

    const target = el.parentElement ? el.parentElement : el
    target.scrollIntoView({ behavior: 'smooth', block: 'center' })

    setTimeout(() => {
      if (el instanceof HTMLElement) {
        el.focus()
      }
    }, 300)
  }, [submitCount, errors, touched])

  return null
}
